import styled from 'styled-components'

export const APP_HEADER_FIXED_HEIGHT = '75px'

export const AppHeader = styled.header<{
  isButtonBackDisabled: boolean
  isMobileMenuOpen: boolean
}>`
  width: 100%;
  background-color: ${(props) => props.theme.palette.backgroundVariant.main};
  z-index: 1206; // needed to render above toolbar drawer

  .header-area {
    height: ${APP_HEADER_FIXED_HEIGHT};
    padding: 0 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;

    @media (min-width: 1200px) {
      padding: 0 30px;
      gap: 30px;
    }

    @media (min-width: 1800px) {
      gap: 40px;
      max-width: 1800px;
      margin: 0 auto;
    }

    .button-back,
    .button-mobile-menu {
      background: none;
      border: none;
      padding: 0;
    }

    .button-back {
      background-color: #ffffff;
      box-shadow: 0 3px 6px rgb(0 0 0 / 16%);
      border-radius: 100px;
      font-size: 22px;
      width: 42px;
      min-width: 42px;
      height: 42px;
      display: flex;
      justify-content: center;
      align-items: center;

      i {
        transform: scaleX(-1) translateY(1px);
        ${(props) => props.isButtonBackDisabled && 'color: #afb0b3;'}
      }

      @media (hover: hover) {
        &:hover {
          ${(props) => props.isButtonBackDisabled && 'cursor: default;'}

          i {
            ${(props) => !props.isButtonBackDisabled && `color: ${props.theme.palette.primary.main};`}
          }
        }
      }
    }

    .button-mobile-menu {
      transform: translateY(2px);

      @media (min-width: 1366px) {
        display: none;
      }

      i {
        font-size: 26px;
      }
    }

    .menu {
      display: flex;
      flex-direction: column;
      gap: 15px;
      position: absolute;
      top: 55px;
      left: 70px;
      z-index: 2;
      box-shadow:
        rgba(0, 0, 0, 0.2) 0px 5px 5px -3px,
        rgba(0, 0, 0, 0.14) 0px 8px 10px 1px,
        rgba(0, 0, 0, 0.12) 0px 3px 14px 2px;
      background: #ffffff;
      padding: 15px 20px 15px 10px;
      opacity: ${(props) => (props.isMobileMenuOpen ? '1' : '0')};
      transform: translateY(${(props) => (props.isMobileMenuOpen ? '0' : '-10px')});
      visibility: ${(props) => (props.isMobileMenuOpen ? 'visible' : 'hidden')};
      pointer-events: ${(props) => (props.isMobileMenuOpen ? 'auto' : 'none')};
      transition:
        opacity 0.2s ease-in-out,
        transform 0.2s ease-in-out,
        visibility 0s ${(props) => (props.isMobileMenuOpen ? '0s' : '0.2s')};

      @media (min-width: 1200px) {
        left: 100px;
      }

      @media (min-width: 1366px) {
        display: flex;
        flex-direction: row;
        gap: initial;
        position: static;
        box-shadow: none;
        background: none;
        padding: 0;
        opacity: 1;
        transform: none;
        visibility: visible;
        pointer-events: auto;
        transition: none;
        align-items: center;
      }

      .menu-item {
        margin-top: 5px;
        margin-bottom: 5px;
        font-size: 18px;

        @media (min-width: 1366px) {
          margin-top: 0;
          margin-bottom: 0;
          font-size: 16px;
          font-weight: 500;

          &:not(:last-child) {
            padding-right: 20px;
            margin-right: 20px;
            border-right: 1px solid #4f504a;
          }
        }

        @media (hover: hover) {
          &:hover {
            i {
              color: inherit;
            }
          }
        }

        button {
          background: none;
          border: none;
          width: 100%;
          padding: 0;
          display: flex;
          align-items: center;

          i {
            font-size: 18px;
            color: #4f504a;
            width: 30px;
            text-align: center;
            margin-right: 5px;
          }

          &[disabled] {
            color: #939393;
            cursor: not-allowed;

            i {
              color: inherit;
            }
          }
        }

        @media (hover: hover) {
          &:not([disabled]):hover {
            color: ${(props) => props.theme.palette.primary.main};

            i {
              color: inherit;
            }
          }
        }
      }
    }
  }
`

export const Logo = styled.img<{
  $isSummaryPanelVisible: boolean
}>`
  display: block;
  width: 110px;
  height: auto;
  margin-top: 0;
  margin-right: 0;
  margin-bottom: 0;
  margin-left: -10px;
  cursor: pointer;
  display: ${(props) => (props.$isSummaryPanelVisible ? 'none' : 'block')};

  @media (min-width: 380px) {
    margin-left: 0;
  }

  @media (min-width: 768px) {
    display: block;
    width: 140px;
  }

  @media (min-width: 1024px) {
    width: 170px;
  }
`

export const ModalBackPrompt = styled.div`
  max-width: 550px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;

  p {
    width: 100%;
  }

  i.fa-sign-out {
    transform: scaleX(-1);
    margin-right: 10px;
  }
`

export const BackLink = styled.a`
  font-family: ${(props) => props.theme.typography.fontFamily};
  font-weight: 500;
  text-decoration: none;
  color: ${(props) => props.theme.palette.primary.main};

  &::before {
    content: '←';
  }

  @media (min-width: 768px) {
    font-size: 22px;

    &::before {
      margin-left: 0.5em;
    }
  }
`
